(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ugc-slider"] && !Shopify.designMode) return;
  try {
    (function () {
    function initSlider(slider) {
      if (slider.dataset.ugcInit) return;
      slider.dataset.ugcInit = '1';

      var track = slider.querySelector('[data-ugc-track]');
      if (!track) return;

      var bar = slider.querySelector('[data-ugc-bar]');
      var thumb = slider.querySelector('[data-ugc-thumb]');

      // Flèches
      slider.querySelectorAll('[data-ugc-arrow]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var cards = track.querySelectorAll('.ugc-slider__card');
          var step = cards.length > 1
            ? cards[1].offsetLeft - cards[0].offsetLeft
            : (cards[0] ? cards[0].offsetWidth : track.clientWidth * 0.8);
          track.scrollBy({ left: btn.dataset.ugcArrow === 'next' ? step : -step, behavior: 'smooth' });
        });
      });

      // Lecture vidéo
      track.querySelectorAll('.ugc-slider__card--video').forEach(function (card) {
        var video = card.querySelector('video');
        if (!video || video.hasAttribute('autoplay')) return;
        var btn = card.querySelector('.ugc-slider__play');
        function toggle() {
          if (video.paused) {
            video.setAttribute('controls', '');
            video.play();
            card.classList.add('is-playing');
          } else {
            video.pause();
            card.classList.remove('is-playing');
          }
        }
        if (btn) btn.addEventListener('click', toggle);
        video.addEventListener('ended', function () {
          card.classList.remove('is-playing');
          video.removeAttribute('controls');
        });
      });

      // Barre de progression
      if (bar && thumb) {
        var updateBar = function () {
          var maxScroll = track.scrollWidth - track.clientWidth;
          var ratio = track.scrollWidth > 0 ? track.clientWidth / track.scrollWidth : 1;
          var thumbW = Math.min(100, Math.max(ratio * 100, 12));
          thumb.style.width = thumbW + '%';
          var progress = maxScroll > 0 ? track.scrollLeft / maxScroll : 0;
          thumb.style.left = (progress * (100 - thumbW)) + '%';
          bar.classList.toggle('is-inactive', maxScroll <= 2);
        };
        track.addEventListener('scroll', updateBar, { passive: true });
        window.addEventListener('resize', updateBar);
        updateBar();

        // Glisser la barre
        var dragging = false, startX = 0, startScroll = 0;
        thumb.addEventListener('pointerdown', function (e) {
          dragging = true;
          startX = e.clientX;
          startScroll = track.scrollLeft;
          thumb.classList.add('is-dragging');
          if (thumb.setPointerCapture) thumb.setPointerCapture(e.pointerId);
        });
        thumb.addEventListener('pointermove', function (e) {
          if (!dragging) return;
          var maxScroll = track.scrollWidth - track.clientWidth;
          var travel = bar.clientWidth - thumb.offsetWidth;
          var dx = e.clientX - startX;
          track.scrollLeft = startScroll + (travel > 0 ? (dx / travel) * maxScroll : 0);
        });
        var endDrag = function () {
          dragging = false;
          thumb.classList.remove('is-dragging');
        };
        thumb.addEventListener('pointerup', endDrag);
        thumb.addEventListener('pointercancel', endDrag);
      }
    }

    document.querySelectorAll('.ugc-slider').forEach(initSlider);
    document.addEventListener('shopify:section:load', function (e) {
      e.target.querySelectorAll('.ugc-slider').forEach(initSlider);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
